import { render, staticRenderFns } from "./DetalleComprobanteTable.vue?vue&type=template&id=0d980ec4&scoped=true&"
import script from "./DetalleComprobanteTable.vue?vue&type=script&lang=js&"
export * from "./DetalleComprobanteTable.vue?vue&type=script&lang=js&"
import style0 from "./DetalleComprobanteTable.vue?vue&type=style&index=0&id=0d980ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d980ec4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
